import React from 'react';

export const DividendsAreNotGuaranteed = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Dividends are reviewed annually and are not guaranteed. Some policies may not receive dividends in a particular year or years even while other policies receive dividends. For universal life products, in lieu of dividends, experience is reflected through changes to nonguaranteed charges and credits.
    </>
  );
};

export const GlobalMarketIntelligence = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Latest U.S. rank as of 2020 based on direct premiums written. Source: S&#38;P Global Market Intelligence. Prepared and calculated by Northwestern Mutual.
    </>
  );
};

export const GlobalMarketIntelligenceForDisability = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;S&#38;P Global Market Intelligence. Prepared and calculated by Northwestern Mutual. U.S. rank based on direct premiums earned. Disability income insurance rank reflects Individual Business, Long&#45;Term category &#40;benefit periods longer than two years&#41;.
    </>
  );
};

export const HighestFinancialStrengthRatings = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Northwestern Mutual continues to have the highest available financial strength ratings awarded to any U.S. life insurer by all four of the major rating agencies: A.M. Best Company, A&#43;&#43; &#40;highest&#41;, 10&#47;24&#59; Fitch Ratings, AAA &#40;highest&#41;, 1&#47;25; Moody&#39;s Ratings, Aa1 &#40;second highest&#41;, 5&#47;25&#59; S&#38;P Global Ratings, AA&#43; &#40;second highest&#41;, 4&#47;24. Third&#45;party ratings are subject to change. Ratings are for The Northwestern Mutual Life Insurance Company and Northwestern Long Term Care Insurance Company.
    </>
  );
};

export const BasedOnClientData = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Based on Northwestern Mutual client data.
    </>
  );
};

export const LoyaltyBasedOnClientData = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Loyalty is based on Northwestern Mutual client data.
    </>
  );
};

export const LoyaltyBasedOnClientDataInsuranceProducts = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Loyalty is based on Northwestern Mutual client data for all individual insurance products offered in 2023.
    </>
  );
};

export const NerdWalletAllRightsReserved = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;&#169;2017&#8211;2024 and TM, NerdWallet, Inc. All Rights Reserved.
    </>
  );
};

export const PermanentLifeDeathBenefit = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;The primary purpose of permanent life insurance is to provide a death benefit. Using permanent life insurance accumulated value to supplement retirement income will reduce the death benefit and may affect other aspects of the policy.
    </>
  );
};

export const PlanningAndProgressStudy = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Northwestern Mutual 2023 Planning &#38; Progress study.
    </>
  );
};

export const RankingNmInvestmentsServices = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Ranking for Northwestern Mutual Investment Services, LLC. Measured by 2022 Revenue. Source: <em>InvestmentNews</em>, May 2023.
    </>
  );
};

export const YourPolicysCashValue = (num) => {
  return (
    <>
      <sup>{num}</sup>&nbsp;Your policy&#39;s cash value typically becomes a useful source of funds only after several years of premium payments, which allows the cash value to build up. Each method of utilizing your policy&#39;s cash value has advantages and disadvantages and is subject to different tax consequences. Surrenders of, withdrawals from and loans against a policy will reduce the policy&#39;s cash surrender value and death benefit and may also affect any dividends paid on the policy. As a general rule, surrenders and withdrawals are taxable to the extent they exceed the cost basis of the policy, while loans are not taxable when taken. Loans taken against a life insurance policy can have adverse effects if not managed properly. Policy loans and automatic premium loans, including any accrued interest, must be repaid in cash or from policy values upon policy termination or the death of the insured. Repayment of loans from policy values (other than death proceeds) can potentially trigger a significant tax liability, and there may be little or no cash surrender value remaining in the policy to pay the tax. If loans equal or exceed the cash value, the policy will terminate if additional cash payments are not made. Policyowners should consult with their tax advisors about the potential impact of any surrenders, withdrawals or loans.
    </>
  );
};

